import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import { spreadsData } from "./data/spreads";

/** Позиция расклада */
export interface ISpreadPosition {
  /** Стабильный технический ID позиции. */
  id: string;
  title: string;
  meaning: string;
}

/** Описание расклада */
export interface ISpread {
  id: string;
  name: string;
  altNames?: string[];
  purpose: string;
  cardsCount: number;
  layout: string; // описание или ASCII/ссылка на схему
  positions: ISpreadPosition[];
  symbolism?: string;
  archetypes?: string[];
  psychology?: string;
  procedure: {
    preparation: string;
    steps: string;
  };
  interpretations?: string[];
  nuances?: string[];
  examples?: { cards: string[]; interpretation: string }[];
  selfQuestions?: string[];
}

/** Состояние */
export interface ISpreadsState {
  items: ISpread[];
}

const initialState: ISpreadsState = {
  items: spreadsData,
};

export const spreadsSlice = createSlice({
  name: "spreads",
  initialState,
  reducers: {},
});

// Селектор
export const selectSpreads = (state: RootState) => state.spreads.items;

export default spreadsSlice.reducer;


